export default {"src":"/_next/static/media/eye-fill.9b14298d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};